import { useState } from "react";

export const useGradientCrossFade = (gradient: string) => {
	const [slots, setSlots] = useState<[string, string]>([gradient, gradient]);
	const [frontSlot, setFrontSlot] = useState<0 | 1>(0);
	const [lastGradient, setLastGradient] = useState(gradient);

	if (lastGradient !== gradient) {
		const nextSlot = frontSlot === 0 ? 1 : 0;
		setSlots((current) =>
			nextSlot === 0 ? [gradient, current[1]] : [current[0], gradient],
		);
		setFrontSlot(nextSlot);
		setLastGradient(gradient);
	}

	return { slots, frontSlot };
};
